import { situacoes } from '@/core/constants'

export default {
	methods: {
		redirecionarPara(url) {
			window.open(url, '_blank')
		},
		isDocumento(documento) {
			if (typeof documento === 'object') {
				return documento.tipoRegistroDocumento === this.tipoDocumentoRegistro.DOC_EDITOR.value
			} else if (typeof documento === 'string') {
				return documento === this.tipoDocumentoRegistro.DOC_EDITOR.value
			}
		},
		isAnexo(anexo) {
			if (typeof anexo === 'object') {
				return anexo.tipoRegistroDocumento === this.tipoDocumentoRegistro.ANEXO.value
			} else if (typeof anexo === 'string') {
				return anexo === this.tipoDocumentoRegistro.ANEXO.value
			}
		},
		isAnexoPdf(anexo) {
			return anexo.extensao === this.extensoesArquivos.PDF.extensao
		},
		documentoEstaCriado(documento) {
			return documento.situacao === situacoes.DOCUMENTO.CRIADO.value
		},
		documentoOuAnexoEstaJuntado(documentoOuAnexo) {
			return documentoOuAnexo.situacao === situacoes.DOCUMENTO.JUNTADO.value
		},
		documentoOuAnexoEstaDesatualizado(documentoOuAnexo) {
			return documentoOuAnexo.situacao === situacoes.DOCUMENTO.DESATUALIZADO.value
		},
		documentoOuAnexoEstaJuntadoDesatualizado(documentoOuAnexo) {
			return documentoOuAnexo.situacao === situacoes.DOCUMENTO.JUNTADO_DESATUALIZADO.value
		},
		documentoOuAnexoEstaEmRascunho(documentoOuAnexo) {
			return documentoOuAnexo.situacao === situacoes.DOCUMENTO.RASCUNHO.value
		},
		documentoOuAnexoEstaCancelado(documentoOuAnexo) {
			return documentoOuAnexo.situacao === situacoes.DOCUMENTO.CANCELADO.value
		},
		possuiTermoDesentranhamento(documento) {
			return documento.possuiTermoDesentranhamento === 'SIM'
		},
		temProcessoDigital(documento) {
			return documento.situacao && !this.documentoEstaCriado(documento) && this.isProcessoDigitalAtivo
		},
	},
}
